import * as Yup from "yup";

const Validation = (coinBalance = null) =>
  Yup.object({
    transactionType: Yup.string().required("Please select a transaction type"),
    coin: Yup.string().required("Please select a coin"),
    amount: Yup.number()
      .typeError("Amount must be a number")
      .positive("Amount must be greater than 0")
      .required("Amount is required")
      .when([], {
        is: () => coinBalance !== null,
        then: (schema) =>
          schema.max(coinBalance, `Amount cannot exceed available balance (${coinBalance})`),
      }),
    type: Yup.string().required("Please select a type"),
    comment: Yup.string().required("Comment is required"),
  });

export default Validation;